module.exports = __webpack_public_path__ + "img/volant.92568646.png";